import styled from 'styled-components'

import { _M_Normal, _XS_Medium, mainColors } from '../../styles'

export const LegendContainer = styled.div`
  display: flex;
  padding: 8px 0;
  gap: 24px;
  justify-content: center;
  ${_M_Normal}
`

export const LegendItemTitle = styled.div`
  position: relative;
  line-height: 1.2;
  & > div {
    position: absolute;
    color: ${mainColors.neutralExtremelyDark};
    ${_XS_Medium}
  }
`

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 20px;
  line-height: 20px;
  ${LegendItemTitle} {
    white-space: nowrap;
    color: ${mainColors.neutralExtremelyDark};
    ${_M_Normal}
  }
  &:first-child {
    justify-content: start;
  }
  &:last-child {
    justify-content: end;
  }
`

export const Circle = styled.div<{ color?: string }>`
  width: 10px;
  height: 10px;
  background-color: ${({ color }) => color ?? mainColors.neutralMedium};
  border-radius: 8px;
`
